import { z } from 'zod';

export const FILTER_ACCOUNT_STATES = ['active', 'cancelled'] as const;

export type FilterAccountsStatesKeys = (typeof FILTER_ACCOUNT_STATES)[number];

export const clientAccountsFilterFormSchema = z.object({
	accountState: z.enum(FILTER_ACCOUNT_STATES).prefault('active'),
});

export type ClientAccountsFilterForm = z.infer<
	typeof clientAccountsFilterFormSchema
>;
